<div class="modal-header">
    <h3 class="modal-title" id="modal-title">Sök kund</h3>
    <button type="button" id="btnLreClose" class="btn-close" aid="buttonLevClose"
        aria-describedby="stäng sök kund"
        (click)="dismissClick()"></button>
</div>

<div class="modal-body p-3">
    <div class="row mb-2" [formGroup]="form">
        <rask-input
            formControlName="text"
            class="col-3"
            label="Namn, ort eller Pnr/Orgnr"
            placeholder="Namn, ort eller Pnr/Orgnr">
        </rask-input>

        <rask-input
            formControlName="adress"
            class="col-3"
            label="Adress"
            placeholder="Adress">
        </rask-input>

        <rask-input
            formControlName="kundnummer"
            class="col-3"
            label="Kundnummer"
            placeholder="Kundnummer">
        </rask-input>

        <rask-input
            formControlName="telefonnummer"
            class="col-3"
            label="Telefonnummer"
            placeholder="Telefonnummer">
        </rask-input>
    </div>

    <rask-button
        class="p-0"
        aid="buttonLevSok"
        color="secondary"
        icon="far fa-search"
        [disabled]="loading"
        (click)="searchClick()">
        @if(loading){
        <rask-busy-spinner size="1"></rask-busy-spinner>
        }
        @else{
        Sök
        }
    </rask-button>


    <div class="mt-2">
        @if(kunder$ | async; as kunder){
        <div>Sökresultat: {{ kunder.length }} träffar</div>

        @if(kunder.length > 0){
        <rask-list
            [fixedHeader]="true"
            [virtualScroll]="true"
            [virtualScrollItemHeight]="45"
            [data]="kunder">
            <rask-list-column header="Namn" field="namn" width="150px"></rask-list-column>
            <rask-list-column header="Person/Orgnr" field="personOrgnummer" width="100px"></rask-list-column>
            <rask-list-column header="Adress" field="adress" width="130px"></rask-list-column>
            <rask-list-column header="Telefonnummer" field="telefon"></rask-list-column>
            <rask-list-column header="Kundnr" field="kundnummer"></rask-list-column>
            <rask-list-column>
                <ng-template let-row="row">
                    <rask-button
                        aid="btn-kund-add"
                        color="primary"
                        (click)="addClick(row)">
                        Välj
                    </rask-button>
                </ng-template>
            </rask-list-column>
        </rask-list>
        }
        @else{
        <i>Inga kunder hittades</i>
        }
        }
        @else {
        <i>Sök på kunder för att hitta kund att lägga till i avtalet</i>
        }
    </div>

    <div class="modal-footer mt-2">
        <rask-button
            aid="btn-kund-cancel"
            color="secondary"
            (click)="dismissClick()">
            Avbryt
        </rask-button>
    </div>
</div>